export type BannerType = "info" | "warn" | "error"

export interface BannerItem {
  type: BannerType
  message: string
}

export interface SystemBannerState {
  system: BannerItem | null
  property: BannerItem | null
}

export const SYSTEM_BANNER_FETCH            = "SYSTEM_BANNER_FETCH"
export const SYSTEM_BANNER_SET              = "SYSTEM_BANNER_SET"
export const SYSTEM_BANNER_RESET            = "SYSTEM_BANNER_RESET"
export const SYSTEM_BANNER_RESET_SYSTEM     = "SYSTEM_BANNER_RESET_SYSTEM"
export const SYSTEM_BANNER_RESET_PROPERTY   = "SYSTEM_BANNER_RESET_PROPERTY"

export interface SystemBannerFetch {
  type: typeof SYSTEM_BANNER_FETCH
}

export interface SystemBannerSet {
  type: typeof SYSTEM_BANNER_SET
  payload: { system: BannerItem | null; property: BannerItem | null }
}

export interface SystemBannerReset {
  type: typeof SYSTEM_BANNER_RESET
}

export interface SystemBannerResetSystem {
  type: typeof SYSTEM_BANNER_RESET_SYSTEM
}

export interface SystemBannerResetProperty {
  type: typeof SYSTEM_BANNER_RESET_PROPERTY
}

export type SystemBannerAction =
  | SystemBannerFetch
  | SystemBannerSet
  | SystemBannerReset
  | SystemBannerResetSystem
  | SystemBannerResetProperty
